import React from "react";
import "./styles.css";

export default function GameButton({ text, onClick, variant = "primary", style }) {
  return (
    <button style={{ style }} className={`pushable ${variant}`} onClick={onClick}>
      <span className="shadow"></span>
      <span className="edge"></span>
      <span className="front">{text}</span>
    </button>
  );
}
